import banner from "../../assets/svg/homeBanner.svg";
import tw, { styled } from "twin.macro";
import { COLORS } from "../../lib/styles/styles";

export const HomeWrapper = styled.div`
	${tw`w-full p-4 md:p-6 m-0 flex flex-row flex-wrap`};
	overflow-y: scroll;

	.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child {
		display: none;
	}
	.ant-progress-inner {
		overflow: visible !important;
	}
	.ant-progress-bg {
		&::after {
			content: "";
			padding: 8px;
			background-color: ${COLORS.appPink} !important;
			display: block;
			position: absolute;
			right: 0;
			top: -4.5px;
			border-radius: 50%;
		}
	}

	.main {
		width: 70%;
		flex: 3;
		padding: 0px 24px 24px 0;

		@media (max-width: 1217px) {
			padding: 0px 24px 24px 24px;
			height: fit-content;
		}
		.banner {
			${tw`flex p-5 flex-col sm:flex-row flex-wrap text-white items-center justify-between`}
			background: url(${banner});
			min-height: 180px;
			min-width: 245px;
			background-repeat: no-repeat;
			background-position: center;
			background-size: cover;
			background-blend-mode: multiply;
			border-radius: 20px;
			background-color: ${COLORS.appLightPink};
			/* padding: 20px; */
		}

		.tell-story {
			background: #ffffff;
			border: 1px solid #f0f6fd !important;
			box-shadow: 0px 10px 40px rgba(231, 237, 243, 0.4);
			border-radius: 20px;
			.action-title {
				${tw`opacity-70 font-bold text-xs md:text-sm leading-5 pt-1`}
			}
			.card-container {
				-ms-overflow-style: none; /* IE and Edge */
				scrollbar-width: none;
				&::-webkit-scrollbar {
					display: none;
				}
			}
		}

		.pre-header {
			font-size: 0.875rem;
			opacity: 0.5;
		}
		@media (max-width: 1217px) {
			width: 100%;
			padding: 0px;
		}
	}

	.fadedBg {
		background: rgb(255, 255, 255, 0.1);
		border: 1.152px solid rgba(255, 255, 255, 0.1);
		box-sizing: border-box;
		border-radius: 32.256px;
	}

	.midFadedBg {
		background: rgba(50, 50, 50, 0.5);
		backdrop-filter: blur(4px);
		border-radius: 50px;
	}

	.sider {
		display: block;
		@media (max-width: 1217px) {
			display: none;
		}
	}

	.no-scroll {
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}
	}
`;

export const HomeTimelineWrapper = styled.div`
	flex: 1;
	height: fit-content;
	display: none;
	width: 100%;
	@media (max-width: 1217px) {
		display: block;
	}
`;

export const UpcomingWeddingContainer = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	overflow-x: auto;
	gap: 8px;
	margin: 2px 0;
`;
